import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error("Uncaught error:", error, errorInfo);
    }
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#e8ecf1] text-slate-800 p-4">
          <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center border border-slate-200">
            <h2 className="text-2xl font-bold text-red-700 mb-4">Something went wrong</h2>
            <p className="text-slate-600 mb-6">
              We apologize for the inconvenience. An unexpected error has occurred.
            </p>
            {process.env.NODE_ENV === 'development' && (
              <details className="text-left bg-slate-50 p-4 rounded mb-6 overflow-auto max-h-48 text-xs font-mono text-slate-600 border border-slate-200">
                <summary className="cursor-pointer mb-2 text-slate-700">Error Details</summary>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </details>
            )}
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-[#002b5c] hover:bg-[#001f45] text-white rounded border border-[#001f45] transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
